import { useState } from 'react';
import { Link } from 'react-router-dom';
import ReviewSlider from '../components/ReviewSlider';

export default function Home() {
  const [activePanel, setActivePanel] = useState(0); // Default til Kvalitet & Tillid (index 0)

  const [contactData, setContactData] = useState({
    name: '',
    phone: '',
    email: '',
    service: 'Privat Vinduespolering',
    description: '',
    website_url: '',
  });

  const [contactStatus, setContactStatus] = useState({
    type: '', // 'success', 'error', 'loading'
    message: '',
  });

  const handleContactChange = (e) => {
    const { name, value } = e.target;
    setContactData((prev) => ({ ...prev, [name]: value }));
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setContactStatus({ type: 'loading', message: 'Sender din besked...' });

    if (!contactData.name.trim() || !contactData.phone.trim() || !contactData.email.trim() || !contactData.description.trim()) {
      setContactStatus({ type: 'error', message: 'Udfyld venligst alle påkrævede felter.' });
      return;
    }

    try {
      const res = await fetch('https://api.dev.auxo.dk/webform/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: contactData.name,
          phone: contactData.phone,
          email: contactData.email,
          subject: `Henvendelse fra forside: ${contactData.service}`,
          description: contactData.description,
          website_url: contactData.website_url,
        }),
      });

      const data = await res.json();

      if (res.ok && data.status === 'ok') {
        setContactStatus({
          type: 'success',
          message: 'Tak! Vi har modtaget din besked og vender tilbage hurtigst muligt.',
        });
        setContactData({
          name: '',
          phone: '',
          email: '',
          service: 'Privat Vinduespolering',
          description: '',
          website_url: '',
        });
      } else {
        setContactStatus({
          type: 'error',
          message: data.message || 'Der skete en fejl under afsendelsen. Prøv venligst igen.',
        });
      }
    } catch (err) {
      console.error('Contact submit error:', err);
      setContactStatus({
        type: 'error',
        message: 'Kunne ikke oprette forbindelse til serveren. Prøv venligst igen.',
      });
    }
  };

  const accordionPanels = [
    {
      id: 0,
      number: '01',
      title: 'Specialist i kirker. Vinduesvask.',
      description: 'Vi er specialister i nænsom og professionel vinduesvask af kirker og historiske bygninger, hvor der kræves særlig ekspertise.',
      cta: 'Læs om os',
      path: '/om-os',
      bgImage: 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=80,format=auto/assets/e40be0c5-fb9a-4c6f-b41e-69a05bb6d2d7/20260630-183611285-ios.jpg',
    },
    {
      id: 1,
      number: '02',
      title: 'Erhvervs Vinduespolering',
      description: 'Professionel vinduespolering til butikker, kontorer, klinikker og erhvervsbygninger. Faste aftaler og fleksibel planlægning.',
      cta: 'Se erhverv',
      path: '/ydelser/erhvervs-vinduespolering',
      bgImage: 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=80,format=auto/assets/e40be0c5-fb9a-4c6f-b41e-69a05bb6d2d7/20260630-183706701-ios_1.jpg',
    },
    {
      id: 2,
      number: '03',
      title: 'Privat Vinduespolering',
      description: 'Skinnende rene vinduer i dit hjem. Vi pudser både ude og inde i parcelhuse, villaer, lejligheder og sommerhuse.',
      cta: 'Se privat',
      path: '/ydelser/privat-vinduespolering',
      bgImage: 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=80,format=auto/assets/e40be0c5-fb9a-4c6f-b41e-69a05bb6d2d7/672330188-1459533669298354-5069136850237555422-n.jpg',
    },
    {
      id: 3,
      number: '04',
      title: 'Tagrende rens',
      description: 'Effektiv rensning af tagrender, der forebygger vandskader og sikrer optimal vandafledning. Praktisk service.',
      cta: 'Se tagrende rens',
      path: '/ydelser/tagrende-rens',
      bgImage: 'https://assets.auxodev.dk/cdn-cgi/image/width=1200,quality=80,format=auto/assets/e40be0c5-fb9a-4c6f-b41e-69a05bb6d2d7/672333970-1459533575965030-6383088530199860706-n.jpg',
    }
  ];

  const services = [
    {
      title: 'Erhvervs Vinduespolering',
      description: 'Professionel vinduespolering til butikker, kontorer, klinikker og erhvervsbygninger. Faste aftaler og fleksibel planlægning.',
      path: '/ydelser/erhvervs-vinduespolering',
      icon: 'fa-duotone fa-building',
    },
    {
      title: 'Privat Vinduespolering',
      description: 'Skinnende rene vinduer i dit hjem. Vi pudser både ude og inde i parcelhuse, villaer, lejligheder og sommerhuse.',
      path: '/ydelser/privat-vinduespolering',
      icon: 'fa-duotone fa-house',
    },
    {
      title: 'Tagrende rens',
      description: 'Effektiv rensning af tagrender, der forebygger vandskader og sikrer optimal vandafledning. Praktisk service.',
      path: '/ydelser/tagrende-rens',
      icon: 'fa-duotone fa-water-gutter',
    },
  ];

  const benefits = [
    {
      title: 'Lokal vinduespudser',
      description: 'Vi er solidt forankret i Kerteminde og kender lokalområdet ud og ind.',
      icon: 'fa-solid fa-location-dot',
    },
    {
      title: 'Private & erhverv',
      description: 'Vi servicerer både private hjem og alle typer erhvervsvirksomheder.',
      icon: 'fa-solid fa-users',
    },
    {
      title: 'Grundigt arbejde',
      description: 'Vi går aldrig på kompromis med kvaliteten og efterlader altid et flot resultat.',
      icon: 'fa-solid fa-circle-check',
    },
    {
      title: 'Fleksible aftaler',
      description: 'Vi tilpasser os dine behov og finder en fast eller ad-hoc aftale, der passer dig.',
      icon: 'fa-solid fa-calendar-days',
    },
    {
      title: 'Frit valg af metode',
      description: 'Vi tilbyder både rentvandsanlæg og traditionel vinduespolering. Du vælger selv!',
      icon: 'fa-solid fa-wand-magic-sparkles',
    },
    {
      title: 'Mulighed for tagrende rens',
      description: 'Få renset tagrenderne samtidig med vinduespoleringen for en komplet løsning.',
      icon: 'fa-solid fa-broom',
    },
  ];

  const steps = [
    {
      num: '01',
      title: 'Kontakt os',
      description: 'Ring, send en mail eller udfyld vores kontaktformular for et uforpligtende tilbud.',
    },
    {
      num: '02',
      title: 'Vi aftaler opgaven',
      description: 'Vi finder den rette løsning og aftaler tidspunktet, der passer dig bedst.',
    },
    {
      num: '03',
      title: 'Arbejdet udføres grundigt',
      description: 'Vores professionelle vinduespudser udfører opgaven effektivt og med stor omhu.',
    },
    {
      num: '04',
      title: 'Flot og rent resultat',
      description: 'Du kan nyde det krystalklare resultat og det flotte helhedsindtryk af din ejendom.',
    },
  ];

  // Optimerer det store uploadede billede til Hero-sektionen
  const heroImg = 'https://assets.auxodev.dk/assets/e40be0c5-fb9a-4c6f-b41e-69a05bb6d2d7/672330188-1459533669298354-5069136850237555422-n.jpg';
  const optimizedHeroImg = heroImg.replace('assets.auxodev.dk/assets/', 'assets.auxodev.dk/cdn-cgi/image/width=1600,quality=85,format=auto/assets/');

  // Optimerer billedet til "Om os" sektionen
  const aboutImg = 'https://assets.auxodev.dk/assets/e40be0c5-fb9a-4c6f-b41e-69a05bb6d2d7/672333970-1459533575965030-6383088530199860706-n.jpg';
  const optimizedAboutImg = aboutImg.replace('assets.auxodev.dk/assets/', 'assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/');

  return (
    <>
      {/* React 19 Native Metadata Hoisting */}
      <title>Nygaards Vinduespolering</title>
      <meta
        name="description"
        content="Nygaards Vinduespolering tilbyder professionel vinduespolering for private og erhverv i Kerteminde og omegn samt effektiv tagrende rens."
      />

      {/* SECTION 1: Hero Split Section (Design Reference Inspired) */}
      <section className="relative bg-slate-50/50 py-16 lg:py-24 overflow-hidden">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 items-stretch gap-12 lg:grid-cols-2 lg:gap-16">
            
            {/* Left Column (Content Block) */}
            <div className="flex flex-col justify-center items-start gap-6 text-left">
              {/* Pill-shaped eyebrow tag with a dot icon */}
              <div className="inline-flex items-center gap-2 rounded-full bg-brand-blue/10 px-3.5 py-1.5 text-xs font-bold uppercase tracking-widest text-brand-blue">
                <span className="h-2 w-2 rounded-full bg-brand-orange animate-pulse" />
                Nygaards Vinduespolering
              </div>
              
              {/* Large display heading: heavy weight, primary color */}
              <h1 className="font-display text-4xl font-black uppercase tracking-tight text-brand-dark sm:text-5xl lg:text-6xl leading-none">
                Rene Ruder <br />
                <span className="text-brand-blue">Uden Striber</span>
              </h1>
              
              {/* Descriptive body paragraph: standard weight, muted secondary color */}
              <p className="text-sm font-light leading-relaxed text-slate-500 max-w-lg">
                Professionel vinduespolering for private og erhverv i Kerteminde og omegn. Vi hjælper med rene vinduer, flot helhedsindtryk og en service, der er nem at regne med.
              </p>
              
              {/* Row of two partner logos / local badges */}
              <div className="flex items-center gap-4">
                <div className="flex items-center gap-2 border border-slate-200 px-4 py-2 text-xs font-bold uppercase tracking-widest text-slate-400">
                  <i className="fa-solid fa-shield-check text-brand-blue text-base" />
                  <span>Garanti</span>
                </div>
                <div className="flex items-center gap-2 border border-slate-200 px-4 py-2 text-xs font-bold uppercase tracking-widest text-slate-400">
                  <i className="fa-solid fa-location-dot text-brand-orange text-base" />
                  <span>Kerteminde</span>
                </div>
              </div>
              
              {/* Large, pill-shaped primary CTA button with a circular avatar icon embedded on the left */}
              <div className="flex flex-wrap items-center gap-4 mt-2">
                <Link
                  to="/kontakt"
                  className="group inline-flex items-center gap-3 rounded-full bg-brand-blue p-1.5 pr-6 font-display text-xs font-bold uppercase tracking-widest text-white hover:bg-brand-orange transition-all duration-300 hover:scale-105"
                >
                  <div className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-brand-blue">
                    <i className="fa-solid fa-user text-xs" />
                  </div>
                  Få et tilbud
                </Link>
                <a
                  href="tel:27501226"
                  className="font-display text-lg font-black tracking-wider text-brand-dark hover:text-brand-blue transition-colors whitespace-nowrap"
                >
                  27 50 12 26
                </a>
              </div>
              
              {/* Final row of badge icons with accompanying text */}
              <div className="flex flex-wrap items-center gap-x-6 gap-y-2 border-t border-slate-100 pt-6 w-full">
                <div className="flex items-center gap-2 text-xs text-slate-500">
                  <i className="fa-solid fa-check text-brand-blue" />
                  <span>Hurtig service</span>
                </div>
                <div className="flex items-center gap-2 text-xs text-slate-500">
                  <i className="fa-solid fa-check text-brand-blue" />
                  <span>Lokalt forankret</span>
                </div>
                <div className="flex items-center gap-2 text-xs text-slate-500">
                  <i className="fa-solid fa-check text-brand-blue" />
                  <span>Pålidelig aftale</span>
                </div>
              </div>
            </div>
            
            {/* Right Column (Single Image matching height of left column) */}
            <div className="relative w-full h-[200px] sm:h-[280px] lg:h-full lg:min-h-[650px]">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/e40be0c5-fb9a-4c6f-b41e-69a05bb6d2d7/672330188-1459533669298354-5069136850237555422-n.jpg"
                alt="Nygaards Vinduespolering - Arbejde"
                className="lg:absolute lg:inset-0 h-full w-full object-cover max-lg:[object-position:50%_41%] rounded-none shadow-2xl border border-slate-200/50"
              />
            </div>
            
          </div>
        </div>
      </section>

      {/* SECTION 2: "We Provide" Split Feature Section (Design Reference Inspired) */}
      <section className="relative bg-slate-50 overflow-hidden py-20 lg:py-32">
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-16">
            {/* Left Column (Content Block) */}
            <div className="flex flex-col items-start text-left lg:pr-8">
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
                Kvalitetsbevidst vinduespudser
              </span>
              <h2 className="mt-3 font-display text-3xl font-black uppercase tracking-tight text-brand-dark sm:text-4xl lg:text-5xl leading-none">
                Vi Tilbyder <br />
                <span className="text-brand-blue">Professionel Service</span>
              </h2>
              <p className="mt-6 text-sm font-light leading-relaxed text-slate-500 max-w-md">
                Nygaards Vinduespolering leverer krystalklare ruder og professionel service til både private hjem og erhvervsvirksomheder. Vi vægter kvalitet, punktlighed og personlig kundekontakt utrolig højt.
              </p>
              <div className="mt-8">
                <Link
                  to="/kontakt"
                  className="group inline-flex items-center gap-3 rounded-full bg-brand-blue p-1.5 pr-6 font-display text-xs font-bold uppercase tracking-widest text-white hover:bg-brand-orange transition-all duration-300 hover:scale-105"
                >
                  <div className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-brand-blue">
                    <i className="fa-solid fa-arrow-right text-xs" />
                  </div>
                  Få et tilbud
                </Link>
              </div>
            </div>

            {/* Right Column (Image with Overlap Effect) */}
            <div className="relative">
              <div className="relative w-full rounded-none overflow-hidden">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=85,format=auto/assets/e40be0c5-fb9a-4c6f-b41e-69a05bb6d2d7/20260630-183742313-ios_3.jpg"
                  alt="Nygaards Vinduespolering - Rent arbejde"
                  className="w-full h-auto object-contain rounded-none"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 3: Lower Content Block Container (Light Tint Background) */}
      <div className="bg-slate-50/70 pt-20 pb-0">
        {/* Ydelser Sektion */}
        <section className="w-full overflow-hidden">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center mb-16">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
              Vores Ydelser
            </span>
            <h2 className="mt-2 font-display text-3xl font-bold uppercase tracking-wider text-brand-blue">
              Hvad tilbyder vi?
            </h2>
            <div className="mx-auto mt-4 h-0.5 w-12 bg-brand-orange" />
            <p className="mx-auto mt-6 max-w-2xl text-sm font-light leading-relaxed text-slate-500">
              Vi leverer professionelle løsninger tilpasset dine behov. Klik på en ydelse for at læse mere og se galleri.
            </p>
          </div>

          {/* Interactive Accordion Slider */}
          <div className="flex flex-col lg:flex-row w-full h-auto lg:h-[550px] overflow-hidden rounded-none">
            {accordionPanels.map((panel) => {
              const isActive = activePanel === panel.id;
              return (
                <div
                  key={panel.id}
                  onMouseEnter={() => setActivePanel(panel.id)}
                  onClick={() => setActivePanel(panel.id)}
                  className={`relative transition-all duration-500 ease-in-out cursor-pointer overflow-hidden rounded-none flex flex-col justify-between ${
                    isActive
                      ? 'bg-brand-blue text-white flex-[1] lg:flex-[2.5] h-[320px] lg:h-full'
                      : 'bg-slate-900 text-slate-300 flex-[1] lg:flex-[0.6] h-[90px] lg:h-full border-b lg:border-b-0 lg:border-r border-slate-800'
                  }`}
                >
                  {/* Background Image with Overlay */}
                  <div
                    className="absolute inset-0 bg-cover bg-center transition-transform duration-700 ease-in-out"
                    style={{
                      backgroundImage: `url(${panel.bgImage})`,
                    }}
                  />
                  {/* Overlay Tint */}
                  <div
                    className={`absolute inset-0 transition-colors duration-500 ${
                      isActive
                        ? 'bg-brand-blue/90 mix-blend-multiply'
                        : 'bg-slate-950/75 hover:bg-slate-950/65'
                    }`}
                  />

                  {/* Content Container */}
                  <div className="relative z-10 flex flex-col justify-between h-full p-6 lg:p-10 select-none">
                    {/* Top Part */}
                    <div className="flex items-start justify-between">
                      {/* Title */}
                      <div
                        className={`transition-all duration-500 ${
                          isActive
                            ? 'opacity-100 translate-y-0'
                            : 'opacity-80 lg:opacity-100 lg:rotate-90 lg:origin-left lg:translate-x-6 lg:translate-y-4 whitespace-nowrap'
                        }`}
                      >
                        <h3 className="font-display text-lg lg:text-xl font-bold uppercase tracking-wider text-white">
                          {panel.title}
                        </h3>
                      </div>

                      {/* Number */}
                      <span className="text-xs font-bold tracking-widest text-white/40 font-display">
                        {panel.number}
                      </span>
                    </div>

                    {/* Bottom Part */}
                    <div
                      className={`transition-all duration-500 ${
                        isActive
                          ? 'opacity-100 translate-y-0'
                          : 'opacity-0 translate-y-4 pointer-events-none h-0 lg:h-auto overflow-hidden'
                      }`}
                    >
                      <p className="text-xs font-light leading-relaxed text-slate-100 max-w-md">
                        {panel.description}
                      </p>
                      <Link
                        to={panel.path}
                        className="mt-6 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-brand-orange hover:text-white transition-colors"
                      >
                        {panel.cta} <i className="fa-solid fa-arrow-right text-[10px]" />
                      </Link>
                    </div>
                  </div>

                  {/* Oversized structural display number in bottom corner */}
                  <div
                    className={`absolute bottom-2 right-4 select-none pointer-events-none font-display font-black text-7xl lg:text-9xl transition-all duration-500 ${
                      isActive ? 'text-white/10 scale-110' : 'text-white/5'
                    }`}
                  >
                    {panel.number}
                  </div>
                </div>
              );
            })}
          </div>
        </section>

        {/* Fordele Sektion (Design Reference Inspired: 1:2 Split Layout with Highlighted Card) */}
        <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 mt-24">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16 items-start">
            {/* Introductory Column (1st Column) */}
            <div className="flex flex-col items-start text-left lg:sticky lg:top-32">
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
                Hvorfor vælge os?
              </span>
              <h2 className="mt-3 font-display text-3xl font-black uppercase tracking-tight text-brand-dark sm:text-4xl leading-none">
                Dine fordele <br />
                <span className="text-brand-blue">hos Nygaards</span>
              </h2>
              <p className="mt-6 text-sm font-light leading-relaxed text-slate-500">
                Vi leverer altid den højeste kvalitet og sørger for, at dine ruder fremstår krystalklare. Se vores mange fordele her, og kontakt os for et uforpligtende tilbud.
              </p>
              <div className="mt-8">
                <Link
                  to="/kontakt"
                  className="group inline-flex items-center gap-3 rounded-full bg-brand-blue p-1.5 pr-6 font-display text-xs font-bold uppercase tracking-widest text-white hover:bg-brand-orange transition-all duration-300 hover:scale-105"
                >
                  <div className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-brand-blue">
                    <i className="fa-solid fa-arrow-right text-xs" />
                  </div>
                  Få et tilbud
                </Link>
              </div>
            </div>

            {/* Grid of Service Cards (spans 2 columns on desktop) */}
            <div className="lg:col-span-2">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {benefits.map((benefit, index) => {
                  const isHighlighted = index === 0; // Highlight the first card ("Lokal vinduespudser")
                  return (
                    <div
                      key={benefit.title}
                      className={`rounded-none border p-8 shadow-none transition-all duration-300 ${
                        isHighlighted
                          ? 'bg-brand-blue text-white border-brand-blue shadow-xl'
                          : 'bg-white text-slate-700 border-slate-200'
                      }`}
                    >
                      <h3 className={`font-display text-base font-bold uppercase tracking-wider ${
                        isHighlighted ? 'text-white' : 'text-brand-dark'
                      }`}>
                        {benefit.title}
                      </h3>
                      <p className={`mt-3 text-xs font-light leading-relaxed ${
                        isHighlighted ? 'text-slate-100' : 'text-slate-500'
                      }`}>
                        {benefit.description}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </section>

        {/* Proces Sektion */}
        <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 mt-24">
          <div className="text-center">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
              Processen
            </span>
            <h2 className="mt-2 font-display text-3xl font-bold uppercase tracking-wider text-brand-blue">
              Så nemt er det
            </h2>
            <div className="mx-auto mt-4 h-0.5 w-12 bg-brand-orange" />
          </div>

          <div className="mt-16 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {steps.map((step, idx) => (
              <div key={step.num} className="relative flex flex-col items-center text-center">
                {/* Forbindelseslinje på desktop */}
                {idx < 3 && (
                  <div className="absolute top-6 left-[60%] right-[-40%] hidden h-[1px] bg-slate-200 lg:block" />
                )}
                <div className="flex h-12 w-12 items-center justify-center rounded-none border border-slate-200 bg-white font-display text-sm font-bold text-brand-blue">
                  {step.num}
                </div>
                <h3 className="mt-6 font-display text-base font-bold uppercase tracking-wider text-brand-dark">
                  {step.title}
                </h3>
                <p className="mt-2 text-xs font-light leading-relaxed text-slate-500">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* Combined Contact and Newsletter Section */}
        <section className="relative mt-24 w-full">
          {/* Upper Split Contact Card */}
          <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 relative z-20">
            <div className="grid grid-cols-1 lg:grid-cols-12 bg-white rounded-none shadow-2xl border border-slate-200/80 overflow-hidden">
              
              {/* Left Column (Form) */}
              <div className="lg:col-span-7 bg-white p-8 sm:p-12 lg:p-16 flex flex-col justify-center">
                <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
                  <i className="fa-solid fa-paper-plane" />
                  <span>Få et uforpligtende tilbud</span>
                </div>
                <h2 className="mt-3 font-display text-2xl sm:text-3xl font-black uppercase tracking-tight text-brand-dark leading-none">
                  Skal vi hjælpe med <br />
                  <span className="text-brand-blue">dine ruder?</span>
                </h2>
                <p className="mt-4 text-sm font-light leading-relaxed text-slate-500">
                  Udfyld formularen nedenfor, så vender vi tilbage med et skræddersyet og uforpligtende tilbud inden for 24 timer.
                </p>

                {/* Status Messages */}
                {contactStatus.message && (
                  <div className={`mt-6 p-4 rounded-none text-xs font-medium ${
                    contactStatus.type === 'success' ? 'bg-green-50 text-green-800 border border-green-200' :
                    contactStatus.type === 'error' ? 'bg-red-50 text-red-800 border border-red-200' :
                    'bg-blue-50 text-blue-800 border border-blue-200'
                  }`}>
                    {contactStatus.message}
                  </div>
                )}

                <form onSubmit={handleContactSubmit} className="mt-8 space-y-6">
                  {/* Honeypot Antispam Field */}
                  <div className="sr-only absolute" aria-hidden="true">
                    <label htmlFor="website_url">Hjemmeside URL</label>
                    <input
                      id="website_url"
                      type="text"
                      name="website_url"
                      value={contactData.website_url}
                      onChange={handleContactChange}
                      tabIndex="-1"
                      autoComplete="off"
                    />
                  </div>

                  {/* First 4 fields in 2-column grid */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div className="flex flex-col">
                      <label htmlFor="name" className="text-xs font-bold uppercase tracking-wider text-brand-dark mb-2">
                        Navn <span className="text-brand-orange">*</span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        required
                        value={contactData.name}
                        onChange={handleContactChange}
                        placeholder="Dit fulde navn"
                        className="rounded-none border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-800 placeholder-slate-400 focus:border-brand-blue focus:bg-white focus:outline-none transition-colors"
                      />
                    </div>

                    <div className="flex flex-col">
                      <label htmlFor="phone" className="text-xs font-bold uppercase tracking-wider text-brand-dark mb-2">
                        Telefon <span className="text-brand-orange">*</span>
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        required
                        value={contactData.phone}
                        onChange={handleContactChange}
                        placeholder="Dit telefonnummer"
                        className="rounded-none border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-800 placeholder-slate-400 focus:border-brand-blue focus:bg-white focus:outline-none transition-colors"
                      />
                    </div>

                    <div className="flex flex-col">
                      <label htmlFor="email" className="text-xs font-bold uppercase tracking-wider text-brand-dark mb-2">
                        E-mail <span className="text-brand-orange">*</span>
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        required
                        value={contactData.email}
                        onChange={handleContactChange}
                        placeholder="Din e-mailadresse"
                        className="rounded-none border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-800 placeholder-slate-400 focus:border-brand-blue focus:bg-white focus:outline-none transition-colors"
                      />
                    </div>

                    <div className="flex flex-col">
                      <label htmlFor="service" className="text-xs font-bold uppercase tracking-wider text-brand-dark mb-2">
                        Ydelse
                      </label>
                      <select
                        id="service"
                        name="service"
                        value={contactData.service}
                        onChange={handleContactChange}
                        className="rounded-none border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-800 focus:border-brand-blue focus:bg-white focus:outline-none transition-colors"
                      >
                        <option value="Privat Vinduespolering">Privat Vinduespolering</option>
                        <option value="Erhvervs Vinduespolering">Erhvervs Vinduespolering</option>
                        <option value="Tagrende rens">Tagrende rens</option>
                        <option value="Andet">Andet</option>
                      </select>
                    </div>
                  </div>

                  {/* Message field spans full width */}
                  <div className="flex flex-col">
                    <label htmlFor="description" className="text-xs font-bold uppercase tracking-wider text-brand-dark mb-2">
                      Besked <span className="text-brand-orange">*</span>
                    </label>
                    <textarea
                      id="description"
                      name="description"
                      required
                      rows="4"
                      value={contactData.description}
                      onChange={handleContactChange}
                      placeholder="Fortæl os kort om opgaven (f.eks. antal vinduer, etager osv.)"
                      className="rounded-none border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-800 placeholder-slate-400 focus:border-brand-blue focus:bg-white focus:outline-none transition-colors resize-none"
                    />
                  </div>

                  <div>
                    <button
                      type="submit"
                      disabled={contactStatus.type === 'loading'}
                      className="rounded-full bg-brand-blue px-8 py-4 font-display text-xs font-bold uppercase tracking-[0.2em] text-white shadow-none hover:bg-brand-orange transition-all duration-300 hover:scale-105 w-full sm:w-auto disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {contactStatus.type === 'loading' ? 'Sender...' : 'Få et tilbud'}
                    </button>
                  </div>
                </form>
              </div>

              {/* Right Column (Image & Floating Callout) */}
              <div className="lg:col-span-5 relative min-h-[350px] lg:min-h-full bg-slate-100 overflow-hidden">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/e40be0c5-fb9a-4c6f-b41e-69a05bb6d2d7/20260630-183754981-ios1.jpg"
                  alt="Nygaards Vinduespolering i Kerteminde"
                  className="absolute inset-0 h-full w-full object-cover rounded-none"
                />
                
                {/* Floating Callout Card */}
                <div className="absolute bottom-8 left-8 right-8 bg-white p-6 rounded-none shadow-xl border border-slate-100 flex items-center gap-4 z-10">
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-brand-orange text-white">
                    <i className="fa-solid fa-phone text-base" />
                  </div>
                  <div>
                    <span className="text-[10px] font-bold uppercase tracking-widest text-slate-400 block">Ring direkte</span>
                    <a href="tel:27501226" className="text-sm font-bold text-brand-dark hover:text-brand-blue transition-colors block whitespace-nowrap">
                      27 50 12 26
                    </a>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>
      </div>
    </>
  );
}
